import { useState } from 'react';

/* <TheoLogo />
   ----------------------------------------------------------
   Single source of truth for the styled "theo" wordmark — a
   chunky pixel-art mark with the cyan→purple→magenta gradient.

   Renders /assets/theo-api-logo.avif at the requested height
   with nearest-neighbor scaling so the pixel grid stays crisp
   at every size. Falls back to a Press Start 2P "theo" if the
   asset is missing or the browser can't decode AVIF, so the
   page never breaks and the brand still reads as pixelated.

   Use this anywhere the Theo brand mark or the lowercase
   "theo" wordmark appears — nav, showcase card title, product
   deep-dive hero, preview card, stage hero, CTA band, and
   footer products list. */
export default function TheoLogo({
  height = 80,
  alt = 'Theo',
  style,
  className,
  ...rest
}) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    /* Press Start 2P is a true pixel font, so its lowercase "e"
       reads as the standard pixel-art e (square shell with the
       horizontal mid-bar) — matches the brand mark.
       The metrics are tall relative to the visible glyph, so we
       scale the font-size to ~0.7× the requested height. The
       cyan→purple→magenta gradient mirrors the PNG's color sweep
       so the fallback still feels like the same wordmark. */
    return (
      <span
        aria-label={alt}
        role="img"
        className={className}
        style={{
          fontFamily: "'Press Start 2P', 'JetBrains Mono', monospace",
          fontWeight: 400,
          fontSize: Math.round(height * 0.7),
          letterSpacing: '0.02em',
          lineHeight: 1,
          background:
            'linear-gradient(95deg, var(--theo-a) 0%, var(--theo-b) 50%, var(--theo-c) 100%)',
          WebkitBackgroundClip: 'text',
          backgroundClip: 'text',
          color: 'transparent',
          display: 'inline-block',
          ...style,
        }}
        {...rest}
      >
        theo
      </span>
    );
  }

  return (
    <img
      src="/assets/theo-api-logo.avif"
      alt={alt}
      onError={() => setFailed(true)}
      className={className}
      style={{
        height,
        width: 'auto',
        display: 'block',
        /* Keep the pixel grid crisp — disable browser smoothing on
           every scale step. `pixelated` is the modern keyword; the
           legacy variants cover Safari and old Firefox. */
        imageRendering: 'pixelated',
        WebkitImageRendering: 'pixelated',
        MozImageRendering: 'crisp-edges',
        ...style,
      }}
      {...rest}
    />
  );
}
